import { EventEmitter } from 'fbemitter'
const AudioContext = window.AudioContext || window.webkitAudioContext;

export default class Analyzer extends EventEmitter {
  constructor (audio) {
    super()

    this.context = new AudioContext();
    this.node = this.context.createScriptProcessor(2048, 1, 1);

    this.analyser = this.context.createAnalyser();
    this.analyser.smoothingTimeConstant = 0.3;
    this.analyser.fftSize = 512;
    this.bands = new Uint8Array(this.analyser.frequencyBinCount);

    audio.addEventListener('canplay', () => {
      this.source = this.context.createMediaElementSource(audio);
      this.source.connect(this.analyser);
      this.analyser.connect(this.node);
      this.node.connect(this.context.destination);
      this.source.connect(this.context.destination);

      this.node.onaudioprocess = () => {
        this.analyser.getByteFrequencyData(this.bands);
        if (!audio.paused) {
          this.update(this.bands);
        }
      }
    })
  }

  update (bands) {
    this.emit('bands', bands);
  }
}



/** WEBPACK FOOTER **
 ** ./src/Analyzer.js
 **/